<template>
  <div class="IntegratedQuery">
    <div class="IntegratedQuery-main">
      <div class="main-child">
        <span class="search-title">综合查询</span>
        <el-input placeholder="请输入内容" v-model="content" class="input">
          <!-- <template slot="append">.com</template> -->
          <el-button slot="append" icon="el-icon-search" class="button" @click="EnterSearch()">
            <span class="span">搜索</span>
          </el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      content: '',
      Position: 'running'
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    EnterSearch() {
      if (this.content) {
        this.$router.push({
          name: '综合查询',
          path: '/search',
          query: { searchVal: JSON.stringify(this.content) }
        });
      }else{
        this.$message('请输入搜索内容');
      }
    }
  }
};
</script>
<style lang="scss">
@import './css/common.scss';
.IntegratedQuery {
  background-color: #fff;
  .IntegratedQuery-main {
    overflow: hidden;
    background-color: #fff;
    height: 80px;
    .main-child {
      height: 80px;
      display: flex;
      align-items: center;
    }

    .input {
      width: 70%;
      min-width: 300px;
      .button {
        background-color: #0f77f2;
        border-radius: 0px 4px 4px 0px;
        width: 80px;
        .el-icon-search {
          color: #ffffff;
        }
        .span {
          color: #ffffff;
        }
      }
    }
    .search-title {
      padding: 20px;
      min-width: 63px;
      //加了引入bootstrap后的信息公开后高度塌陷
      // height: 17px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;
    }
  }
}
</style>